import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Actions_Wind from '~/Actions_Wind';
import excel from '~/skills/excel';
import { S_Btn_Search, S_Select, S_Title } from '~/components/SearchItem';
import { T_TableRow, T_TitleCell } from '~/components/TableItem';
import ExportButton from '~/components/Button/ExportButton';
import SearchBar from '~/components/SearchBar';

// const list = [
//   { a: '＃2', b: '8.4', c: 'Ａ', d: '110/7/1-111/10/1', e: '已完工' },
//   { a: '＃2', b: '12.5', c: 'Ｂ', d: '111/11/1-112/12/31', e: '已簽約' },
//   { a: '工業專業區 H區', b: '17', c: 'Ｂ', d: '111/11/1-112/12/31', e: '已簽約' },
// ];

const RenderTableTitle = () => {
  const ary = [
    { name: '碼頭編號' },
    { name: '後線土地使用面積' },
    { name: '使用風場' },
    { name: '承租期間' },
    { name: '其他' },
  ];
  return (
    <TableHead>
      <TableRow style={{ height: 48 }}>
        {ary.map((o, i) => (
          <T_TitleCell
            key={i}
            text={o.name}
          />
        ))}
      </TableRow>
    </TableHead>
  );
};

const RenderTableBody = () => {
  const list = useSelector(state => state.data.WindsPierList || []);

  const cellStyle = { fontSize: 14 };

  return (
    <TableBody>
      {list.map((o, i) => (
        <T_TableRow key={i}>
          <TableCell align='center' style={cellStyle}>{o.near_land}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.rent_space}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.windfield_simplename}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.rent_date}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.other}</TableCell>
        </T_TableRow>
      ))}
    </TableBody>
  );
};

const RenderTable = () => {
  const list = useSelector(state => state.data.WindsPierList || []);

  const haveData = list.length > 0;
  return (
    <TableContainer>
      <Table style={{ backgroundColor: 'white', borderRadius: 8 }}>
        <RenderTableTitle />
        {haveData && <RenderTableBody />}
      </Table>
    </TableContainer>
  );
};

const App = props => {
  const [port, setPort] = useState('');
  const dispatch = useDispatch();

  const getWindsPierList = () => Actions_Wind.Gis.getWindsPierList(dispatch, { dock: port });

  useEffect(() => getWindsPierList(), []);
  const onClickSearch = () => getWindsPierList();

  const list = useSelector(state => state.data.WindsPierList || []);
  const PSPierList = useSelector(state => state.data.PSPierList || []);
  const haveData = list.length > 0;

  const onExport = () => {
    if (list.length === 0) {
      alert('無匯出資料');
    } else {
      excel.outputAryAry({
        data: list.map((o = {}) => ([
          o.near_land,
          o.rent_space,
          o.windfield_simplename,
          o.rent_date,
          o.other,
        ])),
        header: [
          '碼頭編號',
          '後線土地使用面積',
          '使用風場',
          '承租期間',
          '其他',
        ],
        fileName: `多風場碼頭系統_港口資訊_${port}`,
      });
    }
  };

  return [
    <div key='1' style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
      <ExportButton style={{ marginRight: 28 }} onClick={onExport} />
    </div>,
    <SearchBar key='2' style={{ marginTop: 16 }} text='港口資訊'>
      <div style={{ display: 'flex' }}>
        <div>
          <S_Title text='港口' />
          <S_Select list={PSPierList} value={port} onChange={d => setPort(d)} />
        </div>
        <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
          <S_Btn_Search onClick={onClickSearch} />
        </div>
      </div>
      <div style={{ marginLeft: 52, marginRight: 52, marginTop: 20, marginBottom: 20 }}>
        <div style={{ borderRadius: 8, boxShadow: '0px 4px 13px rgba(24, 98, 121, 0.4)' }}>
          <RenderTable />
          {/* {haveData && this.renderTableBar()} */}
        </div>
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
      </div>
    </SearchBar>,
  ];
};

export default App;
